import { supabase } from '../supabaseClient';

/**
 * Mirror the cart server-side once we know who the shopper is, so
 * shinyvault-cart-reminder can email them if they leave. See migration
 * 20260919120000_shinyvault_cart_recovery.sql for the sequence and its limits.
 *
 * Fire-and-forget like tracking: a failure here must never block checkout.
 * For a signed-in shopper the server ignores `email` and uses the account's.
 */
const EMAIL_RE = /^[^@\s]+@[^@\s]+\.[^@\s]+$/;

export function captureCart(email, items, source) {
  try {
    if (source === 'checkout' && !EMAIL_RE.test(String(email || '').trim())) return;
    supabase.rpc('sv_capture_cart', {
      p_email: email ? String(email).trim() : null,
      p_items: items.map((i) => ({ product_id: i.product_id, quantity: i.quantity })),
      p_source: source,
    }).then(() => {}, () => {});
  } catch { /* never block the page */ }
}
